declare const require: any;
export const environment = {
  production: true,
  apiURL: 'https://stdag.metasoft-testing.com',
  pathData: '/frnt/dist/appSifac/',
  url: 'https://stdag.metasoft-testing.com',
  ambiente:'Desarrollo-Server',
  version: require('../../package.json').version,
  emailProd: false,
  systemStartDate: '2025-03-28' // Fecha inicial para filtrar SOP
};
